/*
 * lph-home-products.js – <lph-home-products> for sections/lph-home-products.liquid.
 * - Image slider per card: scroll-snap track, dots (aria-current) and, with a fine pointer, arrows.
 * - Row mode: more cards than fit form one swipeable row; arrow buttons scroll it by one card.
 * - « Ajouter au panier » for products without variants: POST /cart/add.js, then Dawn's cart drawer
 *   (or cart notification) re-renders and opens, and the cart count updates. Without JS (or without
 *   a cart drawer) the real <form> posts to /cart as usual.
 */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('lph-home-products')) return;

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function behavior() {
    return reduceMotion && reduceMotion.matches ? 'auto' : 'smooth';
  }

  function Slider(card) {
    this.card = card;
    this.track = card.querySelector('[data-lph-track]');
    this.dots = Array.prototype.slice.call(card.querySelectorAll('[data-lph-dot]'));
    this.prev = card.querySelector('[data-lph-prev]');
    this.next = card.querySelector('[data-lph-next]');
    this.count = this.track ? this.track.children.length : 0;
    this.timer = null;
    if (!this.track || this.count < 2) return;
    var self = this;
    this.track.addEventListener(
      'scroll',
      function () {
        clearTimeout(self.timer);
        self.timer = setTimeout(function () {
          self.sync();
        }, 60);
      },
      { passive: true }
    );
    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.go(parseInt(dot.getAttribute('data-lph-dot'), 10) || 0);
      });
    });
    if (this.prev)
      this.prev.addEventListener('click', function () {
        self.go(self.index() - 1);
      });
    if (this.next)
      this.next.addEventListener('click', function () {
        self.go(self.index() + 1);
      });
    this.sync();
  }

  Slider.prototype.index = function () {
    var w = this.track.clientWidth || 1;
    return Math.max(0, Math.min(this.count - 1, Math.round(this.track.scrollLeft / w)));
  };

  Slider.prototype.go = function (i) {
    i = Math.max(0, Math.min(this.count - 1, i));
    var left = i * this.track.clientWidth;
    try {
      this.track.scrollTo({ left: left, behavior: behavior() });
    } catch (e) {
      this.track.scrollLeft = left;
    }
    this.sync(i);
  };

  Slider.prototype.sync = function (forced) {
    var i = typeof forced === 'number' ? forced : this.index();
    this.dots.forEach(function (dot, n) {
      if (n === i) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    // A disabled arrow leaves the tab order (disabled) instead of keeping an invisible focus stop;
    // if it had the focus, the focus moves to the other arrow.
    var active = document.activeElement;
    var atStart = i <= 0;
    var atEnd = i >= this.count - 1;
    if (this.prev) {
      this.prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      this.prev.disabled = atStart;
    }
    if (this.next) {
      this.next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      this.next.disabled = atEnd;
    }
    if (atStart && active === this.prev && this.next) this.next.focus();
    if (atEnd && active === this.next && this.prev) this.prev.focus();
  };

  function flashLabel(button, text, ms) {
    var label = button.querySelector('[data-lph-btn-label]');
    if (!label || !text) return;
    if (button.lphLabelTimer) clearTimeout(button.lphLabelTimer);
    if (button.lphOriginal == null) button.lphOriginal = label.textContent;
    label.textContent = text;
    button.lphLabelTimer = setTimeout(function () {
      label.textContent = button.lphOriginal;
      button.lphLabelTimer = null;
    }, ms);
  }

  function setStatus(form, text, ok) {
    var status = form.querySelector('[data-lph-error]');
    if (!status) return;
    status.classList.toggle('is-ok', !!ok);
    status.textContent = text || '';
  }

  function addToCart(form, event) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!window.fetch || !cart || typeof cart.renderContents !== 'function') return; // plain form post
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    var body = { items: [{ id: Number(form.elements.id.value), quantity: Number(form.elements.quantity.value) || 1 }] };
    if (typeof cart.getSectionsToRender === 'function') {
      body.sections = cart
        .getSectionsToRender()
        .map(function (s) {
          return s.id;
        })
        .join(',');
      body.sections_url = window.location.pathname;
    }
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    setStatus(form, '');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        if (!res || res.status) {
          setStatus(form, (res && (res.description || res.message)) || 'Une erreur est survenue. Veuillez réessayer.');
          return;
        }
        // cart/add.js with items[] returns { items: [...], sections: {...} }; Dawn expects the item at the root.
        var state = res.items && res.items.length ? Object.assign({}, res.items[0], { sections: res.sections }) : res;
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(state);
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'lph-home-products',
            productVariantId: body.items[0].id,
            cartData: state
          });
        }
        setStatus(form, 'Article ajouté au panier.', true);
        flashLabel(button, button.getAttribute('data-added-label'), 2000);
      })
      .catch(function () {
        setStatus(form, 'Une erreur est survenue. Veuillez réessayer.');
      })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  // Row of cards (row mode): arrow buttons scroll by one card; an arrow is disabled at its end of the row and both
  // are disabled when the row does not overflow (e.g. a layout where all cards fit).
  function Row(root) {
    this.list = root.querySelector('[data-lph-row]');
    this.prev = root.querySelector('[data-lph-row-prev]');
    this.next = root.querySelector('[data-lph-row-next]');
    this.timer = null;
    if (!this.list || (!this.prev && !this.next)) return;
    var self = this;
    this.list.addEventListener(
      'scroll',
      function () {
        clearTimeout(self.timer);
        self.timer = setTimeout(function () {
          self.sync();
        }, 60);
      },
      { passive: true }
    );
    if (this.prev)
      this.prev.addEventListener('click', function () {
        self.step(-1);
      });
    if (this.next)
      this.next.addEventListener('click', function () {
        self.step(1);
      });
    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(function () {
        self.sync();
      });
      this.observer.observe(this.list);
    }
    this.sync();
  }

  Row.prototype.step = function (dir) {
    var card = this.list.firstElementChild;
    var gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
    var by = card ? card.getBoundingClientRect().width + gap : this.list.clientWidth;
    try {
      this.list.scrollBy({ left: dir * by, behavior: behavior() });
    } catch (e) {
      this.list.scrollLeft += dir * by;
    }
  };

  Row.prototype.sync = function () {
    var max = this.list.scrollWidth - this.list.clientWidth;
    var left = this.list.scrollLeft;
    var active = document.activeElement;
    // A few px of tolerance: scroll snap can stop a card 1–2 px from the exact edge.
    var atStart = max <= 4 || left <= 4;
    var atEnd = max <= 4 || left >= max - 4;
    if (this.prev) this.prev.disabled = atStart;
    if (this.next) this.next.disabled = atEnd;
    if (atStart && active === this.prev && this.next && !atEnd) this.next.focus();
    if (atEnd && active === this.next && this.prev && !atStart) this.prev.focus();
  };

  class LphHomeProducts extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (!this.lphRow) this.lphRow = new Row(this);
      this.querySelectorAll('[data-lph-card]').forEach(function (card) {
        if (!card.lphSlider) card.lphSlider = new Slider(card);
      });
      this.onSubmit = function (event) {
        var form = event.target.closest && event.target.closest('[data-lph-add-form]');
        if (form && self.contains(form)) addToCart(form, event);
      };
      this.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.onSubmit);
      if (this.lphRow && this.lphRow.observer) this.lphRow.observer.disconnect();
    }
  }

  customElements.define('lph-home-products', LphHomeProducts);
})();
